/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casedataresetshort3Inputs */

const en_casedataresetshort3 = /** @type {(inputs: Casedataresetshort3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`undo`)
};

const pt_casedataresetshort3 = /** @type {(inputs: Casedataresetshort3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anular`)
};

/**
* | output |
* | --- |
* | "undo" |
*
* @param {Casedataresetshort3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casedataresetshort3 = /** @type {((inputs?: Casedataresetshort3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casedataresetshort3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casedataresetshort3(inputs)
	return pt_casedataresetshort3(inputs)
});
export { casedataresetshort3 as "caseDataResetShort" }